import { nsPartners } from '@/app/i18n/namespaces';
import { FIELD_TYPES } from '@/common-utils/components/renders/detailsGrid/FieldTypes';
import { FILTER_TYPES } from '@/common-utils/components/renders/dataTable/filter/FilterTypes';

export default {
    UUID: {
        key: 'uuid',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.uuid',
        namespace: nsPartners,
        placeholder: 'filter.placeholder.uuid',
        filter: FILTER_TYPES.INPUT,
        enableSorting: false
    },
    LEGAL_NAME: {
        key: 'legalName',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.legal_name',
        namespace: nsPartners,
        placeholder: 'filter.placeholder.legal_name',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    },
    CONNECTION_POINTS: {
        key: 'connectionPoints',
        type: FIELD_TYPES.ARRAY,
        entity: 'keys.ports',
        namespace: nsPartners,
        placeholder: 'filter.placeholder.ports',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true,
        PORTS: {
            parentKeys: ['connectionPoints'],
            key: 'port',
            type: FIELD_TYPES.TEXT
        }
    },
    REGISTRATION_NUMBER: {
        key: 'registrationNumber',
        type: FIELD_TYPES.TEXT,
        entity: 'keys.registration_number',
        namespace: nsPartners,
        placeholder: 'filter.placeholder.registration_number',
        filter: FILTER_TYPES.INPUT,
        enableSorting: true
    }
};